export interface 並び順区分型 {
    値: string;
    ラベル: string;
}

export const 並び順区分一覧: 並び順区分型[] = [
    {値: '商品名', ラベル: '商品名'},
    {値: '規格容量', ラベル: '規格・容量'},
    {値: 'メーカー名', ラベル: 'メーカー名'},
];
